import { fetcher } from "helpers/fetcher";

import { TGetEmployeeSettingRes } from "./types";
import { API_HEADER } from "../constants";
import { ENDPOINT } from "../endpoint";

export const getEmployeeSetting = async (userId: string) => {
  return await fetcher<TGetEmployeeSettingRes, any>(
    ENDPOINT.USER.GET_EMPLOYEE_SETTING,
    {
      headers: {
        [API_HEADER.VERSION]: ENDPOINT.USER.GET_EMPLOYEE_SETTING.version,
        [API_HEADER.USER_ID]: userId,
      },
    }
  );
};

export const queryGetEmployeeSetting = async (userId: string) => {
  return (await getEmployeeSetting(userId)).data;
};

queryGetEmployeeSetting._key = (userId: string) => [
  ENDPOINT.USER.GET_EMPLOYEE_SETTING.url,
  userId,
];
